// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3NIju","large":"styles_large__2-8YQ"};